<template>
  <v-app>
    <v-app-bar
      v-if="loggedIn"
      app
      color="white"
      class="elevation-0"
    >
      <div class="ma-5 py-4">
        <v-img src="./assets/RareCyte_Header_Logo.png" />
      </div>
      <v-spacer></v-spacer>
      <div>
        <v-text-field
          v-model="searchPortal"
          class="mt-7"
          outlined
          dense
          label="Search Portal"
          clear-icon="mdi-close"
          clearable
          append-icon="mdi-magnify"
          @click:append="searchPost"
          @click:clear="searchPortal=''"
          @keydown.enter="searchPost"
        ></v-text-field>
      </div>
      <v-divider vertical class="mx-5"></v-divider>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            class="ma-5 py-4 d-none d-lg-flex"
            v-bind="attrs"
            v-on="on"
            text
            x-small
          >
           Welcome, {{ customerName }}
            <v-icon class="">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item 
            link
            to="/my-account"
          >
            <v-list-item-icon>
              <v-icon  small>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item>My Account</v-list-item>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item 
          link
          to="/logout">
            <v-list-item-icon>
              <v-icon small>mdi-power</v-icon>
            </v-list-item-icon>
            <v-list-item>Logout</v-list-item>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-app-bar-nav-icon class="ma-5 py-4 d-flex d-lg-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      v-if="loggedIn"
      v-model="drawer"
      fixed
      temporary
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          active-class="secondary white--text"
        >
          <v-list-item
            link
            to="/home"
          >
            <v-list-item-icon>
              <v-icon>mdi-home-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item
            v-for="item in navigation.top"
            :key="item.category_id"
            link
            :to="item.category_slug"
          >
            <v-list-item-icon>
              <v-icon v-text="item.category_icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.category_name_display"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            link
            to="/my-account"
          >
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>My Account</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            to="/logout"
          >
            <v-list-item-icon>
              <v-icon>mdi-power</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      
    </v-navigation-drawer>
   
    <v-card 
      v-if="loggedIn"
      id="top-navigation" 
      class="d-none d-lg-flex"
      color="white"
    >
    
      <v-card-text class="text-center my-n2">
        <v-btn
          class="mx-3 text-center"
          text
          link
          active-class="top-nav-active"
          to="/home"
        >
         Home
        </v-btn>

        <v-menu
          v-for="item in topNav"
         :key="item.category_id"
          open-on-hover
          bottom
          offset-y
        >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            text
            link
            active-class="top-nav-active"
            :href="'/#/' + item.category_slug"
          >
            {{ item.category_name_display }}
          </v-btn>
        </template>

        <v-list
          v-for="subItem in item.subcats"
         :key="subItem.category_id"
          nav
          dense
        >
          <v-list-item v-if="subItem.category_slug === 'faq' || subItem.category_slug === 'frequently-asked-questions'"
            link
            :href="'/#/' + subItem.category_slug"
            active-class="top-nav-active"
          >
            {{ subItem.category_name_display }}
          </v-list-item>
          <v-list-item v-else
          active-class="top-nav-active"
          link
          :href="'/#/' + subItem.category_id + '/' + subItem.category_slug"
          >
            {{ subItem.category_name_display }}
          </v-list-item>
        </v-list>
        </v-menu>
        <!-- <v-btn 
        class="mx-3 text-center"
         v-for="item in navigation.top"
         :key="item.category_id"
          text
          link
          active-class="top-nav-active"
          :to="'/' + item.category_id + '/' + item.category_slug"
        >
         {{ item.category_name }}
        </v-btn> -->
      </v-card-text>
      
    </v-card>
    
    <v-main>
      <router-view/>
    </v-main>
    
    <v-footer v-if="loggedIn" class="pa-1">
      <v-container>
        <v-row>
          <v-col class="caption text-center grey--text text--darken-1">
            &copy; Copyright {{ copyright.getFullYear() }} RareCyte, Inc. All rights reserved.<br>
            RareCyte, Inc. 2601 Fourth Ave, #500, Seattle, WA 98121, United States
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
   
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    loggedIn: false,
    drawer: false,
    navigation: {
      top: null,
      side: null
    },
    // topNav: [{"category_id":38,"category_name":"Certificates of Analysis","category_name_display":"Certificates of Analysis","subcats":[{"category_id":39,"category_name":"AccuCyte (Certs)","category_name_display":"AccuCyte","subcats":[]},{"category_id":41,"category_name":"ArgoFluor (Certs)","category_name_display":"ArgoFluor","subcats":[]},{"category_id":40,"category_name":"RarePlex (Certs)","category_name_display":"RarePlex","subcats":[]}]},{"category_id":34,"category_name":"Safety Data Sheets","category_name_display":"Safety Data Sheets","subcats":[{"category_id":35,"category_name":"AccuCyte (SDS)","category_name_display":"AccuCyte","subcats":[]},{"category_id":37,"category_name":"ArgoFluor (SDS)","category_name_display":"ArgoFluor","subcats":[]},{"category_id":36,"category_name":"RarePlex (SDS)","category_name_display":"RarePlex","subcats":[]}]},{"category_id":25,"category_name":"User Guides","category_name_display":"User Guides","subcats":[{"category_id":22,"category_name":"Instruments","category_name_display":"Instruments","subcats":[]},{"category_id":29,"category_name":"Laboratory","category_name_display":"Laboratory","subcats":[]},{"category_id":26,"category_name":"Software","category_name_display":"Software","subcats":[]}]},{"category_id":45,"category_name":"Videos","category_name_display":"Videos","subcats":[]},{"category_id":44,"category_name":"Links","category_name_display":"Links","subcats":[]}],
    // topNav: [{"category_id":62,"category_name":"Documentation","category_name_display":"Documentation","category_slug":"documentation","subcats":[{"category_id":25,"category_name":"User Guides","category_name_display":"User Guides","category_slug":"user-guides","subcats":[]},{"category_id":34,"category_name":"Safety Data Sheets","category_name_display":"Safety Data Sheets","category_slug":"safety-data-sheets","subcats":[]},{"category_id":38,"category_name":"Certificates of Analysis","category_name_display":"Certificates of Analysis","category_slug":"certificates-of-analysis","subcats":[]}]},{"category_id":63,"category_name":"Reagent Catalog","category_name_display":"Reagent Catalog","category_slug":"reagent-catalog","subcats":[]},{"category_id":64,"category_name":"Support","category_name_display":"Support","category_slug":"support","subcats":[{"category_id":65,"category_name":"FAQ","category_name_display":"FAQ","category_slug":"faq","subcats":[]}]},{"category_id":66,"category_name":"Resources","category_name_display":"Resources","category_slug":"resources","subcats":[{"category_id":45,"category_name":"Videos","category_name_display":"Videos","category_slug":"videos","subcats":[]},{"category_id":44,"category_name":"Links","category_name_display":"Links","category_slug":"links","subcats":[]}]}],
    // topNav: [{"category_id":62,"category_name":"Documentation","category_name_display":"Documentation","category_slug":"documentation","subcats":[{"category_id":25,"category_name":"User Guides","category_name_display":"User Guides","category_slug":"user-guides","subcats":[{"category_id":22,"category_name":"Instruments","category_name_display":"Instruments","category_slug":"instruments","subcats":[{"category_id":23,"category_name":"CyteFinder","category_name_display":"CyteFinder","category_slug":"cytefinder","subcats":[]},{"category_id":24,"category_name":"Orion","category_name_display":"Orion","category_slug":"orion","subcats":[]}]}]},{"category_id":34,"category_name":"Safety Data Sheets","category_name_display":"Safety Data Sheets","category_slug":"safety-data-sheets","subcats":[{"category_id":35,"category_name":"AccuCyte (SDS)","category_name_display":"AccuCyte","category_slug":"accucyte","subcats":[]},{"category_id":37,"category_name":"ArgoFluor (SDS)","category_name_display":"ArgoFluor","category_slug":"argofluor","subcats":[]},{"category_id":36,"category_name":"RarePlex (SDS)","category_name_display":"RarePlex","category_slug":"rareplex","subcats":[]}]},{"category_id":38,"category_name":"Certificates of Analysis","category_name_display":"Certificates of Analysis","category_slug":"certificates-of-analysis","subcats":[{"category_id":39,"category_name":"AccuCyte (Certs)","category_name_display":"AccuCyte","category_slug":"accucyte","subcats":[]},{"category_id":41,"category_name":"ArgoFluor (Certs)","category_name_display":"ArgoFluor","category_slug":"argofluor","subcats":[]},{"category_id":40,"category_name":"RarePlex (Certs)","category_name_display":"RarePlex","category_slug":"rareplex","subcats":[]}]}]},{"category_id":63,"category_name":"Reagent Catalog","category_name_display":"Reagent Catalog","category_slug":"reagent-catalog","subcats":[]},{"category_id":64,"category_name":"Support","category_name_display":"Support","category_slug":"support","subcats":[{"category_id":65,"category_name":"FAQ","category_name_display":"Frequently Asked Questions","category_slug":"faq","subcats":[]}]},{"category_id":66,"category_name":"Resources","category_name_display":"Resources","category_slug":"resources","subcats":[{"category_id":45,"category_name":"Videos","category_name_display":"Videos","category_slug":"videos","subcats":[]},{"category_id":44,"category_name":"Links","category_name_display":"Links","category_slug":"links","subcats":[]}]}],
    // topNav: [{"category_id":62,"category_name":"Documentation","category_name_display":"Documentation","category_slug":"documentation","subcats":[{"category_id":25,"category_name":"User Guides","category_name_display":"User Guides","category_slug":"user-guides","subcats":[{"category_id":22,"category_name":"Instruments","category_name_display":"Instruments","category_slug":"instruments","subcats":[{"category_id":23,"category_name":"CyteFinder","category_name_display":"CyteFinder","category_slug":"cytefinder","subcats":[]},{"category_id":24,"category_name":"Orion","category_name_display":"Orion","category_slug":"orion","subcats":[]}]},{"category_id":29,"category_name":"Laboratory","category_name_display":"Laboratory","category_slug":"laboratory","subcats":[{"category_id":30,"category_name":"Liquid Biopsy","category_name_display":"Liquid Biopsy","category_slug":"liquid-biopsy","subcats":[{"category_id":31,"category_name":"Sample Processing","category_name_display":"Sample Processing","category_slug":"sample-processing","subcats":[]},{"category_id":32,"category_name":"RarePlex Staining","category_name_display":"RarePlex Staining","category_slug":"rareplex-staining","subcats":[]}]},{"category_id":33,"category_name":"Spatial Biology","category_name_display":"Spatial Biology","category_slug":"spatial-biology","subcats":[]}]},{"category_id":26,"category_name":"Software","category_name_display":"Software","category_slug":"software","subcats":[{"category_id":28,"category_name":"Artemis","category_name_display":"Artemis","category_slug":"artemis","subcats":[]},{"category_id":27,"category_name":"CyteHub","category_name_display":"CyteHub","category_slug":"cytehub","subcats":[]}]}]},{"category_id":34,"category_name":"Safety Data Sheets","category_name_display":"Safety Data Sheets","category_slug":"safety-data-sheets","subcats":[{"category_id":35,"category_name":"AccuCyte (SDS)","category_name_display":"AccuCyte","category_slug":"accucyte","subcats":[]},{"category_id":37,"category_name":"ArgoFluor (SDS)","category_name_display":"ArgoFluor","category_slug":"argofluor","subcats":[]},{"category_id":36,"category_name":"RarePlex (SDS)","category_name_display":"RarePlex","category_slug":"rareplex","subcats":[]}]},{"category_id":38,"category_name":"Certificates of Analysis","category_name_display":"Certificates of Analysis","category_slug":"certificates-of-analysis","subcats":[{"category_id":39,"category_name":"AccuCyte (Certs)","category_name_display":"AccuCyte","category_slug":"accucyte","subcats":[]},{"category_id":41,"category_name":"ArgoFluor (Certs)","category_name_display":"ArgoFluor","category_slug":"argofluor","subcats":[]},{"category_id":40,"category_name":"RarePlex (Certs)","category_name_display":"RarePlex","category_slug":"rareplex","subcats":[]}]}]},{"category_id":63,"category_name":"Reagent Catalog","category_name_display":"Reagent Catalog","category_slug":"reagent-catalog","subcats":[]},{"category_id":64,"category_name":"Support","category_name_display":"Support","category_slug":"support","subcats":[{"category_id":65,"category_name":"FAQ","category_name_display":"Frequently Asked Questions","category_slug":"faq","subcats":[]}]},{"category_id":66,"category_name":"Resources","category_name_display":"Resources","category_slug":"resources","subcats":[{"category_id":45,"category_name":"Videos","category_name_display":"Videos","category_slug":"videos","subcats":[]},{"category_id":44,"category_name":"Links","category_name_display":"Links","category_slug":"links","subcats":[]}]}],
    topNav: [],
    copyright: new Date(),
    customerName: null,
    customerEmail: null,
    searchPortal: ''
  }),
  beforeMount () {
    this.pageInit()

    this.$root.$on('_logoutCustomer',() => {
      this.logoutCustomer()
    })

    this.$root.$on('notify',(type,msg) => {
      this.showToasts(type,msg)  
    })

  },
  mounted (){
  },
  methods: {
    logoutCustomer () { 
      localStorage.clear()
      localStorage.removeItem('rccpcst')
      this.customerName = null
      this.customerEmail = null
      this.loggedIn = false
    },
    pageInit () {
      
      const loggedIn = localStorage.getItem('rccpcst')
      const pg = this.$route.name
      
      if(loggedIn ){
   
        const userObj = JSON.parse(loggedIn)

        switch(pg) {
          case "SignIn":
            this.$router.push({ path: '/home' })
            break;
          default:
            this.getNavigation()
            this.loggedIn = true
            this.customerName = userObj.firstName
            this.customerEmail = userObj.email
        }

      }else{
        this.loggedIn = false
      }
    },
    searchPost() {
      //alert(this.$route.name) //SearchView
      /**/
      let searchPhrase = this.searchPortal

      if(searchPhrase){

        if(this.$route.name === 'SearchView'){
          this.$root.$emit("_searchContent",searchPhrase)
          this.searchPortal = ''
        }else{
          this.$router.push({
            name: 'SearchView',
            params: {
                search: searchPhrase
            }
          })
          this.searchPortal = ''
        }
        /*

        if(this.$route.name === 'SearchView'){
          
        }else{
          this.$router.push({
            name: 'SearchView',
            params: {
                search: searchPhrase
            }
          })
          this.searchPortal = ''
        }
        */

        
      }
      
    },
    getNavigation () {

      const userObj = JSON.parse(localStorage.getItem('rccpcst'))

      var endpoint = '/portal/settings'
      const url = process.env.VUE_APP_API_BASE_URL + endpoint

      let postData = {
        action: "navigation"
      }
      
      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
        mode: 'cors',
      })  
      fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {
        //V 1
        // if(jsonResponse.success) {
        //   this.navigation.top = jsonResponse.data //set top nav
        //   this.$category.items = jsonResponse.data //make nav json available globally
        // }
         // console.log(jsonResponse.data[0]. category_schema_json)
         
         if(jsonResponse.success) {
          const navObj = JSON.parse(jsonResponse.data[0]. category_schema_json)
          this.topNav = navObj // jsonResponse.data
          
          let navTop = []
          for (let i = 0; i < navObj.length; i++) {
            let obj = {
              category_id: navObj[i].category_id,
              category_name: navObj[i].category_name,
              category_name_display: navObj[i].category_name_display,
              category_slug: navObj[i].category_slug,
              category_description: navObj[i].category_description,
            }
            navTop.push(obj)
          }
          
          this.navigation.top = navTop // jsonResponse.data //set top nav
          this.$category.items = navTop // jsonResponse.data //make nav json available globally
        }

      })
    },
    showToasts (type,msg) {
      var options = {
        timeout: 3000,
        hideProgressBar: true,
      }
      switch (type) {
        case 'success':
          this.$toast.success(msg, options)
          break
        case 'info':
          this.$toast.info(msg, options)
          break
        case 'warning':
          this.$toast.warning(msg, options)
          break
        case 'error':
          this.$toast.error(msg, options)
          break    
        default:
          this.$toast(msg, options)
      }
    },
  },
  watch: {
    '$route' () {
      this.pageInit()
    }
  },
  components: {

  }
};
</script>
<style>

#top-navigation{
  margin-top: 66px;
}
.top-nav-active{
  color: #b65c39 !important;
}
/*
.v-application, .modal-bg {
  background-color: #f4f4f4 !important; 
}
*/
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
